const NOTIFICATION_LOCATION_ON_PAGE = {
    PRE_HEADER: 'PRE_HEADER',
    BELOW_HEADER: 'BELOW_HEADER',
};

const NOTIFICATION_TYPE = {
    APP_DOWNLOAD: 'APP_DOWNLOAD',
    APP_HERO: 'APP_HERO',
};

const BANNER = 'banner';
const MODAL = 'modal';
const SERP = 'SEARCH_RESULTS';
const defaultCtaLabel = 'Get it Now';
const defaultDismissLabel = 'Not Yet';
export {
    BANNER,
    MODAL,
    NOTIFICATION_LOCATION_ON_PAGE,
    NOTIFICATION_TYPE,
    SERP,
    defaultCtaLabel,
    defaultDismissLabel,
};
